import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { ICarePlanGoal } from './types';

const apiUrl = 'care-plan-goals';

export const getList = (patientId: number): IResponse<ICarePlanGoal[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}`,
  });

export const create = (patientId: number, data: ICarePlanGoal): IResponse<ICarePlanGoal> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
    params: {
      patientId,
    },
  });

export const update = (data: ICarePlanGoal): IResponse<ICarePlanGoal> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
